import React, {useEffect} from 'react';

function RedirectionPage() {

  return (
    <div className='w-full'>
      Redirection Page
    </div>
  )
}

export default RedirectionPage